import React, { useEffect, useState } from 'react'

import { UnitTypeData, UnitTypeStepProps } from '../types'

const UnitTypeStep: React.FC<UnitTypeStepProps> = ({ value, onChange, error }) => {
  const bedroomOptions = ['单身公寓(Studio)', '1', '2', '3', '4+']
  const bathroomOptions = ['1', '2', '3', '4+']

  const [selectedBeds, setSelectedBeds] = useState<string[]>(value.beds)
  const [selectedBaths, setSelectedBaths] = useState<string[]>(value.baths)

  useEffect(() => {
    if (value) {
      setSelectedBeds(value.beds || [])
      setSelectedBaths(value.baths || [])
    }
  }, [value])

  const updateValue = (beds: string[], baths: string[]) => {
    const data: UnitTypeData = { beds, baths }
    onChange(data)
  }

  const toggleBed = (bed: string) => {
    const newBeds = selectedBeds.includes(bed) ? selectedBeds.filter(b => b !== bed) : [...selectedBeds, bed]
    setSelectedBeds(newBeds)
    updateValue(newBeds, selectedBaths)
  }

  const toggleBath = (bath: string) => {
    const newBaths = selectedBaths.includes(bath) ? selectedBaths.filter(b => b !== bath) : [...selectedBaths, bath]
    setSelectedBaths(newBaths)
    updateValue(selectedBeds, newBaths)
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="flex flex-col gap-2">
        <h2 className="text-lg font-bold text-[#1d2129] leading-snug">3. 您期望的户型是？ (Bedrooms & Bathrooms)</h2>
        <p className="text-sm text-gray-500 font-normal">如果您不确定，可以选择多种类型，我们会帮您缩小范围。</p>
      </div>

      {/* Bedrooms */}
      <div className="flex flex-col gap-3">
        <span className="text-sm font-medium text-gray-700">卧室数量 (Bedrooms)</span>
        <div className="flex flex-wrap gap-3">
          {bedroomOptions.map(opt => (
            <div
              key={opt}
              onClick={() => toggleBed(opt)}
              className={`cursor-pointer rounded-lg border px-5 py-3 text-sm font-medium transition-all ${
                selectedBeds.includes(opt)
                  ? 'border-[#050a22] bg-[#050a22] text-white'
                  : 'border-[#e0e2ef] bg-white text-[#050a22] hover:bg-gray-50'
              }`}
            >
              {opt}
            </div>
          ))}
        </div>
      </div>

      {/* Bathrooms */}
      <div className="flex flex-col gap-3">
        <span className="text-sm font-medium text-gray-700">卫生间数量 (Bathrooms)</span>
        <div className="flex flex-wrap gap-3">
          {bathroomOptions.map(opt => (
            <div
              key={opt}
              onClick={() => toggleBath(opt)}
              className={`cursor-pointer rounded-lg border px-5 py-3 text-sm font-medium transition-all ${
                selectedBaths.includes(opt)
                  ? 'border-[#050a22] bg-[#050a22] text-white'
                  : 'border-[#e0e2ef] bg-white text-[#050a22] hover:bg-gray-50'
              }`}
            >
              {opt}
            </div>
          ))}
        </div>
      </div>

      {error && <p className="text-red-500 text-sm font-medium">此问题为必填项</p>}
    </div>
  )
}

export default UnitTypeStep
